// document.addEventListener('DOMContentLoaded', function() {
//     const productTexts = document.querySelectorAll('.product-form__text');
//     const featuresWrapper = document.querySelector('#features-wrapper');

//     if (productTexts.length && featuresWrapper && featuresWrapper.parentNode) {
//         productTexts.forEach(text => {
//             featuresWrapper.parentNode.insertBefore(text, featuresWrapper.nextSibling);
//         });
//     }
// });

$(document).ready(function () {
  if (window.location.href === "https://evolvegamingpc.com.au/products/cables-live?variant=49262960083218") {
    const $btn = $('#AddToCart');
    if ($btn.length) {
      $btn.replaceWith($btn.clone());
    }

    const $sticky = $('.sticky-btn');
    if ($sticky.length) {
      $sticky.removeAttr('disabled')
             .css({   
               opacity: 1,
               cursor: 'pointer'
             });

      $sticky.on('click', function () {
        $('#AddToCart').trigger('click');
      });
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const keywords = ["CPU", "GPU", "RAM", "Cooler", "Case", "PSU", "OS", "Motherboard"];
  const targetId = "extra-product-detail";

  function checkAndShowExtraDetail() {
    const optionBoxes = document.querySelectorAll('#ymq-box .ymq-options-box');

    for (let box of optionBoxes) {
      const label = box.getAttribute('data-label');
      if (label && keywords.includes(label.trim())) {
        const extraDetail = document.getElementById(targetId);
        if (extraDetail) {
          extraDetail.style.display = "block";
          return true;
        }
      }
    }
    return false;
  }

  const interval = setInterval(() => {
    const isVisible = checkAndShowExtraDetail();
    if (isVisible) clearInterval(interval);
  }, 200);

  setTimeout(() => clearInterval(interval), 10000);
});



